import { CognitoUserPool } from "amazon-cognito-identity-js"
import { configure } from './../config';
const poolData = {
    UserPoolId: configure.poolData.UserPoolId,
    ClientId: configure.poolData.ClientId
}
export default new CognitoUserPool(poolData);